export default __webpack_public_path__ + "static/media/img_s1.3125af5c.jpg";